module.exports = __webpack_public_path__ + "media/images/Groupe_right-422901bf5d74fc733347997fa48135b2.svg";